module.exports = __webpack_public_path__ + "img/INTERIOR-ERTIGA-3.a0cff864.jpg";